module.exports = __webpack_public_path__ + "img/company-logo-white.84bd9bf6.svg";